import React, { useContext, useEffect, useState } from "react";
import styles from './styles/AccountActivated.module.css'
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
export function AccountActivated(){
    const navigate = useNavigate()
    const websiteCurrentLang = useContext(LanguageContext).language;
    const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
    );
    useEffect(() => {
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
    }, [websiteCurrentLang]);
return(
    <div className={styles.main}>
        <div className={styles.title}>{dublicatedcontent?.account_is_activated}</div>
        <div onClick={()=>navigate('/login')} className={styles.button}>{dublicatedcontent?.click_here_to_log_in}</div>
        <div className={styles.logo} />
    </div>
)
}